import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_MEGAPACK } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState<boolean>(false);
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-236" data-mp="3gl721rvp0x4j">
      {visible && <motion.div initial={{
      y: 80
    }} animate={{
      y: 0
    }} exit={{
      y: 80
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-gold bg-navy-deep/95 backdrop-blur" data-id="element-237" data-mp="3gkfijffdepum">
          <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-3" data-id="element-238" data-mp="gxz2qopchka7">
            <div className="min-w-0" data-id="element-239" data-mp="7546mv6ca7x7">
              <p className="truncate font-display text-sm font-extrabold text-white sm:text-base" data-id="element-240" data-mp="765ih1v6iyfz">
                MegaPack desde <span className="text-gold" data-id="element-241" data-mp="24pyze8ngzzp">$19.990 ARS</span>
              </p>
              <p className="text-[11px] font-semibold tabular-nums text-celeste-light sm:text-xs" data-id="element-242" data-mp="gx9vhw1ao986">
                Cierra en {hours}:{minutes}:{seconds} · Garantía 7 días
              </p>
            </div>
            <a href={CHECKOUT_MEGAPACK} className="shrink-0 rounded-full border-b-4 border-gold-dark bg-gold px-5 py-2.5 font-display text-sm font-extrabold uppercase text-navy-deep transition-transform hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:px-7 sm:text-base" data-id="element-243" data-mp="puk9hp5hycgs">
              Lo quiero
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}